export default "__VITE_ASSET__DCKiBNYI__"